import React from 'react';
import styled from 'styled-components';

const FarmerList = ({ onSelectFarmer }) => {
  const farmers = [
    { id: 1, name: 'Juan Dela Cruz' },
    { id: 2, name: 'Maria Santos' },
    { id: 3, name: 'Jose Rizal' },
    { id: 4, name: 'Peter Lee' },
    { id: 4, name: 'Santiago Sy' },
  ];

  return (
    <ListWrapper>
      <Header>
        <Title>List of Farmers</Title>
      </Header>
      <FarmersContainer>
        <ul>
          {farmers.map(farmer => (
            <ListItem key={farmer.id} onClick={() => onSelectFarmer(farmer)}>
              {farmer.name}
            </ListItem>
          ))}
        </ul>
      </FarmersContainer>
    </ListWrapper>
  );
};

export default FarmerList;

// Styled Components

const ListWrapper = styled.div`
  width: 100%;
  max-width: 500px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
  padding: 10px;
  margin-top: 0px;
`;

const Header = styled.div`
  background: linear-gradient(45deg, rgb(13, 207, 55), rgb(13, 110, 9));
  padding: -10px 10px;
  border-radius: 8px 8px 0 0;
`;

const Title = styled.h2`
  font-size: 1.2rem;
  color: #fff;
  font-weight: 600;
  margin: 0;
`;

const FarmersContainer = styled.div`
  padding: 10px 15px;
`;

const ListItem = styled.li`
  font-size: 16px;
  color: #333;
  padding: 12px 8px;
  cursor: pointer;
  border-radius: 8px;
  margin-bottom: 8px;
  transition: background 0.3s ease;
  border-bottom: 1px solid #e0e0e0; /* Adding the line between items */

  &:hover {
    background-color: #f1f8e9;
    transform: scale(1.02); /* Slight scale effect on hover */
  }

  &:last-child {
    border-bottom: none; /* Remove bottom border for the last item */
  }
`;
